import React from "react";

// Renders `placeholder` until the wrapper scrolls within `rootMargin` of the
// viewport, then renders `children`. Once mounted, stays mounted.
export default function LazyMount({
    children,
    placeholder = null,
    rootMargin = "300px",
    style,
    className,
}) {
    const ref = React.useRef(null);
    const [visible, setVisible] = React.useState(false);

    React.useEffect(() => {
        if (visible) return;
        const node = ref.current;
        if (!node) return;
        if (typeof IntersectionObserver === "undefined") {
            setVisible(true);
            return;
        }
        const observer = new IntersectionObserver(entries => {
            for (const entry of entries) {
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.disconnect();
                    return;
                }
            }
        }, { rootMargin });
        observer.observe(node);
        return () => observer.disconnect();
    }, [visible, rootMargin]);

    return (
        <div ref={ref} className={className} style={style}>
            {visible ? children : placeholder}
        </div>
    );
}
